<section class="search-result-page py-5">
  <div class="container">
    <div class="search-box-wrapper">
      <div class="search-box flex-column flex-sm-row">
        <div class="input-group" [ngClass]="{'error': hasError}">
          <span class="input-group-text"><iconify [name]="'lucide:search'" /></span>
          <input
            [(ngModel)]="searchTerm"
            (ngModelChange)="hasError = false;"
            (keydown.enter)="onUpdateSearchQuery()"
            class="form-control"
            placeholder="Search by company name, RC number, or PSC name..."
          />
        </div>
        <button class="btn btn-primary align-self-stretch" (click)="onUpdateSearchQuery()">Search Registry</button>
      </div>
      @if (searchQuery() && (!loading() || forceShowTotal()) && (!!companyList()?.length || !!searchResponse()?.totalCompanyCount)) {
        <p class="pt-2 pt-md-0">
          <span class="heading-color-1 fw-bold">Showing {{ searchResponse()?.totalCompanyCount ?? companyList()?.length ?? 0 | number }} results</span>&nbsp;
          <span>for "{{ searchQuery() }}"</span>
        </p>
      }
    </div>

    <div class="border-top my-4"></div>

    <ul class="list-unstyled d-flex flex-column gap-4">
      @if (loading()) {
        @for (i of [1,2,3,4,5,6]; track i) {
          <li class="card card-flexed">
            <div>
              <div><ngx-skeleton-loader appearance="line" [theme]="{maxWidth: '600px'}"  /></div>
              <div><ngx-skeleton-loader appearance="line" [theme]="{maxWidth: '200px'}"  /></div>
            </div>
            <div class="border-bottom"></div>
            <div class="row g-3 line-height-100p">
              <div class="col-sm-6">
                <div><ngx-skeleton-loader appearance="line" [theme]="{maxWidth: '70%'}" /></div>
                <div><ngx-skeleton-loader appearance="line" [theme]="{maxWidth: '50%'}" /></div>
              </div>
              <div class="col-sm-6">
                <div><ngx-skeleton-loader appearance="line" [theme]="{maxWidth: '70%'}" /></div>
                <div><ngx-skeleton-loader appearance="line" [theme]="{maxWidth: '50%'}" /></div>
              </div>
            </div>
          </li>
        }
      } @else {
        @for (c of companyList(); track c.companyId) {
          <li class="card card-flexed">
            <div>
              <div class="d-flex align-items-center flex-wrap gap-2">
                <h3 class="card-title d-inline">{{c.approvedName}}</h3>
                @if (c.status === 'ACTIVE') {
                  <span class="badge bg-success d-inline-flex fs-10">ACTIVE</span>
                } @else {
                  <span class="badge bg-danger d-inline-flex fs-10">{{ c.status }}</span>
                }
              </div>
              <p class="py-1 text-primary fw-bold">RC Number: {{c.rcNumber}}</p>
              <p class="fw-semibold">{{ getCompanyType(c?.companyTypeFk!) }}</p>
            </div>
            <div class="border-bottom"></div>
            <div class="row g-3 line-height-100p">
              <div class="col-sm-6">
                <p class="text-uppercase fs-13 fw-bold pb-2">Date of Registration</p>
                <p class="heading-color-1 fs-15 fw-semibold">{{ getDate(c.registrationDate) | date: 'dd MMMM yyyy' }}</p>
              </div>
              <div class="col-sm-6">
                <p class="text-uppercase fs-13 fw-bold pb-2">Registered Address</p>
                <p class="heading-color-1 fs-15 fw-semibold">{{ c.registeredAddress }}</p>
              </div>
            </div>
            <div class="border-bottom"></div>
            <div class="d-flex align-items-center justify-content-between gap-3 flex-wrap">
              <div class="d-flex align-items-start align-items-sm-center gap-2 heading-color-1 flex-grow-1 lh-1">
                <div class="pt-1 pt-sm-0"><iconify [name]="'lucide:users'" class="fs-18" /></div>
                <p class="fs-14 fw-medium">{{ c?.pscCount ?? 0 }} declared Persons with Significant Control (PSC)</p>
              </div>
              @if (!!c.pscCount && (c.pscCount > 0)) {
                <button class="btn btn-success" [routerLink]="c.companyId?.toString()">View PSC Details</button>
              }
            </div>
          </li>
        }

        @if (!(companyList().length)) {
          <li class="text-center" style="padding: 100px 0;">
            <iconify [size]="70" class="opacity-50" [name]="'lucide:search-slash'" />
            <p class="pt-3 fs-20 fw-bold">No Results Found</p>
            <p class="fs-14 pt-1">For "<span class="heading-font heading-color-1">{{ searchQuery() }}</span>"</p>
          </li>
        }
      }

    </ul>

    <div class="mt-4 pt-3"></div>

    <div class="search-pagination d-flex w-100">
      <button class="btn" (click)="goToPage(pageNumber() - 1)" [disabled]="!canGoBack || loading()"><iconify [name]="'lucide:chevron-left'" /> Previous</button>
      <div class="page-number">Page {{ pageNumber() || 1 }} of {{ searchResponse()?.pagination?.totalPages || 1 }}</div>
      <button class="btn" (click)="goToPage(pageNumber() + 1)" [disabled]="!canGoNext || loading()">Next <iconify [name]="'lucide:chevron-right'" /></button>
    </div>
  </div>
</section>
